export default __webpack_public_path__ + "static/media/line-items-empty-state-icon.7c56af44.svg";